import React, {useEffect, useState, useContext} from "react";
import styled from "styled-components/macro";
import UnifiedButton from '@aseda_library/ui/buttons/UnifiedButton';
import PageTitle from "@as_core/menus/PageTitle";
import UserProfileMenu from "./UserProfileMenu";
import { ThemeSwitcher } from "@as_core/elements/ThemeSwitcher";
import IconBugs from "@as_core/icons/IconBugs";
import { BugsModal } from '@as_core/bugsReporting/bugs.modal';
import { UserContext } from '@as_core/contexts/UserContext';

interface PropsT {
  title: string;
  appTitle: string | React.ReactNode;
  centerBanner?: string | React.ReactNode;
}

const debug = false;

const TopMenu = (props: PropsT) => {
  const { title, appTitle, centerBanner = ''} = props;
  const { user} = useContext(UserContext);
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

  // set user states
  useEffect(()=>{
    setIsAuthorized(user?.isRegistered);
  }, [user]);
  if (debug) console.log('TopMenu | user: ', user, ' isAuthorized:', isAuthorized);

  const [isBugsModalOpen, setIsBugsModalOpen] = useState(false);

  const handleBugs = () => {
    setIsBugsModalOpen((previous) => !previous)
    if (debug) console.log("handleBugs");
  };

  return (
    <>
      <Header>
        <HeaderLeft>
          <PageTitle appTitle={appTitle} title={title} />
        </HeaderLeft>
        <HeaderCenter>{centerBanner}</HeaderCenter>
        <HeaderRight>
          <ItemContainer>
            <ThemeSwitcher />
          </ItemContainer>
          { (isAuthorized) ?
              <>
                <ItemContainer>
              <UnifiedButton
               icon={<IconBugs size={24} />}
               onClick={handleBugs}
               tooltip="Submit a Bug Report"
               tooltipPlacement="bottom"
               margin="0"
             />

                </ItemContainer>
              </>
              :
              <></>
          }
          <ItemContainer>
            <UserProfileMenu user={user}/>
          </ItemContainer>
        </HeaderRight>
      </Header>
      <BugsModal
          modalOpen={isBugsModalOpen}
          setModalOpen={setIsBugsModalOpen}
      />
    </>
  );
};

export default TopMenu;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 50px;
  justify-content: space-between;
  width: 100%;
  margin-bottom: -1px;
  align-items: center;
  background-color: ${(p) => p.theme.palette.backgroundSecondary};
`;

const HeaderLeft = styled.div`
  width: max-content;
  display: flex;
  grid-auto-flow: column;
  justify-self: start;
`;

const HeaderCenter = styled.div`
  display: flex;
  width: max-content;
  flex-direction: column;
  justify-content: center;
`;

const HeaderRight = styled.div`
  display: flex;
  width: max-content;
  justify-content: end;
  padding-right: 20px;
`;

const ItemContainer = styled.div`
  height: 50px;
  padding: 0;
  margin: 0;
  width: max-content;
  align-items: center;
  display: grid;
`;
